import React, { useState } from 'react';
import ParticlesBackground from './ParticlesBackground'; // Assuming you have this component
import api from "../axiosConfig";


const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(''); // Added error state
    const [success, setSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setIsSubmitting(true);
    try {
        await api.post('/forgot-password/', { email });
        setSuccess(true);
    } catch (err) {
        const errorData = err?.response?.data || {};
        setError('Error sending password reset email: ' + (errorData.message || 'An unknown error occurred'));
    } finally {
        setIsSubmitting(false);
    }
};

    return (
        <div style={{ position: 'relative', minHeight: '100vh' }}>
            <ParticlesBackground /> {/* Add the Particles background */}
            <div className="flex items-center justify-center min-h-screen py-4 px-4">
                <form
                    onSubmit={handleSubmit}
                    className="bg-white p-10 rounded-lg shadow-lg w-full sm:w-96 md:w-3/5 lg:w-2/5 xl:w-1/3 max-w-lg mx-auto" // Adjusted form width for larger breakpoints
                    style={{
                        backgroundColor: 'white',
                        zIndex: 1,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <h2 className="text-center text-3xl font-semibold text-[#202531] mb-6">
                        Forgot Password
                    </h2>

                    {/* Success Message */}
                    {success && (
                        <div className="mb-4 text-center text-green-600">
                            <p className="font-semibold">If an account exists for that email, a reset link has been sent.</p>
                            <p className="text-sm mt-1">Check your inbox and spam folder.</p>
                        </div>
                    )}

                    {/* Error Message */}
                    {error && (
                        <div className="mb-4 text-center text-red-500">
                            <p>{error}</p>
                        </div>
                    )}

                    <div className="mb-6">
                        <label htmlFor="email" className="block text-[#202531] mb-2 text-left">
                            Email Address
                        </label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isSubmitting || success}
                            className="w-full p-4 border border-gray-300 rounded-md bg-[#F2F2F2]"
                            style={{
                                backgroundColor: '#F2F2F2',
                                borderColor: '#D1D5DB',
                                color: '#202531',
                            }}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isSubmitting || success}
                        className="mt-2 bg-[#0196BF] text-white font-bold text-xl px-24 py-3 rounded-full hover:bg-[#017BA3] transition z-20 max-w-full mx-auto flex items-center justify-center"
                    >
                        {isSubmitting ? 'Sending…' : success ? 'Email Sent' : 'Send Reset Link'}
                    </button>

                    <div className="mt-4 text-center">
                        <p className="text-sm">
                            Already know your password?{' '}
                            <a
                                href="/login"
                                className="text-[#0196BF] hover:underline"
                            >
                                Login
                            </a>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
